define('shared/initializer/form/adapters/Upsell',[
    'shared/lib/ctor',
    './NativeForm',
    './mixins/upsell/Renderable',
    './mixins/upsell/EventHandlable',
    './mixins/upsell/Submittable',
    './mixins/upsell/ViewModelProvidable',
    './mixins/Redirectable',
    './mixins/CheckoutFlowControllable'
],
function (
    ctor,
    NativeForm,
    Renderable,
    EventHandlable,
    Submittable,
    ViewModelProvidable,
    Redirectable,
    CheckoutFlowControllable
) {
    'use strict';

    function doNothing(){}

    function initSubItems () {
        var me = this;
        var $form = me.$form;
        var $all = $form.find('table.offer > tbody > tr');
        var $cur;
        var fieldName;
        var fieldOptions;

        for( var l = $all.length; l--; ) {
            $cur = $all.eq(l);

            fieldName = $cur.attr('data-offer-id').toLowerCase();

            if (me.items[fieldName]) {
                fieldOptions = me.items[fieldName];
            }
            else {
                fieldOptions = {};
            }

            fieldOptions.type = 'offer';
            fieldOptions.pass = doNothing;
            fieldOptions.fail = doNothing;
            fieldOptions.reset = doNothing;
            fieldOptions.$wrap = $cur;
            fieldOptions.index = $cur.index();
            fieldOptions.$el = $cur;
            fieldOptions.offer = {
                id: fieldName
            };

            me.items.set(
                fieldName, fieldOptions
            );
        }
    }

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply( null, arguments );

        initSubItems.call(me);
        me.offers = {};

        me.mixin(
            Renderable,
            ViewModelProvidable,
            EventHandlable,
            Submittable,
            Redirectable,
            CheckoutFlowControllable
        );

    }).inherit(NativeForm);

    return Ctor;
});

